import { Navigate, Outlet } from 'react-router-dom'
import { useIsAdmin } from '@/lib/hooks/use-is-admin'

export default function AdminRoute() {
  const isAdmin = useIsAdmin()

  if (!isAdmin) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
